// extracted by mini-css-extract-plugin
module.exports = {"FooterBackground":"Footer_FooterBackground__ZHIJs","Footer":"Footer_Footer__238hM","FooterInfo":"Footer_FooterInfo__3y2yW"};